// connection url
export const NOTIFICATION_API_ENDPOINT = process.env.NOTIFICATION_API;

// hubs
export const MEASUREMENT_HUB = NOTIFICATION_API_ENDPOINT + "/measurementhub";
export const STATUS_HUB = NOTIFICATION_API_ENDPOINT + "/samplestatushub";
export const INSTRUMENT_HUB = NOTIFICATION_API_ENDPOINT + "/instrumentstatushub";
export const KEYEDIN_STATUS_HUB = NOTIFICATION_API_ENDPOINT + "/keyedinstatushub";
export const CALCULATED_HUB = NOTIFICATION_API_ENDPOINT + "/calculatedthub";
export const EXCEPTION_HUB = NOTIFICATION_API_ENDPOINT + '/exceptionnotificationhub';
export const MEASUREMENT_AL_HUB = NOTIFICATION_API_ENDPOINT+"/almeasurementstatushub";
// endpoints
export const HUB_SETCONTEXT = 'setContext';
export const MEASUREMENT_HUB_RECEIVE_MEASUREMENT = 'ReceiveMeasurement';
export const MEASUREMENT_HUB_RECEIVE_KEYEDIN = "ReceiveKeyedIn";
export const SAMPLE_HUB_RECEIVE_SAMPLE_STATUS = 'ReceiveSampleStatus';
export const MEASUREMENT_HUB_RECEIVE_MEASUREMENT_COUNT = "ReceiveMeasurementCount";
export const MEASUREMENT_HUB_RECEIVE_INSTRUMENT_STATUS = "ReceiveInstrumentStatus";
export const MEASUREMENT_HUB_RECEIVE_KEYEDIN_COUNT = "ReceieveKeyedInCount";
export const MEASUREMENT_HUB_RECEIVE_KEYEDIN_STATUS = "ReceiveKeyedInStatus";
export const MEASUREMENT_HUB_RECEIVE_CALCULATED_PROPERTY = "ReceiveCalculatedProperty";
export const MEASUREMENT_HUB_AUTOLINE = "ReceiveALMeasurementCount";
export const HANDLE_EXCEPTION = "HandleException";
export const MEASUREMENT_HUB_RECEIVE_AL_STATUS = "ReceiveALMeasurementStatus";
export const RE_TRY_ATTEMPTS:number[] = [0, 1000,3000,5000,10000,30000,60000, null];